import { render, staticRenderFns } from "./theorymatching.vue?vue&type=template&id=8e57c0b8&scoped=true"
import script from "./theorymatching.vue?vue&type=script&lang=js"
export * from "./theorymatching.vue?vue&type=script&lang=js"
import style0 from "./theorymatching.vue?vue&type=style&index=0&id=8e57c0b8&prod&lang=stylus"
import style1 from "./theorymatching.vue?vue&type=style&index=1&id=8e57c0b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e57c0b8",
  null
  
)

export default component.exports